import { Component } from '@angular/core';

@Component({
  selector: 'app-moulding-tools-manufacturing',
  templateUrl: './moulding-tools-manufacturing.component.html',
  styleUrls: ['./moulding-tools-manufacturing.component.scss']
})
export class MouldingToolsManufacturingComponent {
  mouldingtoolone:any[] = [
    {
      description: '28+ years of experience in high-precise connectors, injection, compression, blow and low-pressure moulds',
      img: 'assets/images/capability/pink/moulding_tool_1.JPG',
    },
    {
      description: 'Expertise in both automotive and nonautomotive sectors. Maximum tool handling capacity for a single program​',
      img: 'assets/images/capability/pink/moulding_tool_2.JPG',
    },
    {
      description: 'Supplying global quality moulds to Europe, Africa, Australia, Asia & the USA​',
      img: 'assets/images/capability/pink/moulding_tool_3.JPG',
    }
  ]

  mouldingtooltwo:any[] = [
    {
      description: '150+ tool designers & Moldflow. Primary focus on recruiting core tool and die makers and plastic mould technology',
      img: 'assets/images/capability/pink/moulding_tool_4.JPG',
      heading:'Engineering & Design Strength'
    },
    {
      description: '139+ high-precision 6-axis, 5-axis, and 3-axis CNC milling machine. 94+ CNC EDM & CNC Wire EDM machines',
      img: 'assets/images/capability/pink/moulding_tool_5.JPG',
      heading:'Manufacturing Capabilities'
    },
    {
      description: 'High gloss polishing skills. Dedicated IMG machines. for trials ranging from 15T to 3200T​',
      img: 'assets/images/capability/pink/moulding_tool_6.JPG',
      heading:'Assembly & Trial Strength'
    },
  ]

}
